import React from 'react';
import { Link } from 'react-router-dom';
import { homeGetStarted } from '../../utils/data';
import { started_main } from '../../assets';
import { Button } from '../../styles';
import styled from 'styled-components';


const GetStarted = () => {

    return (
        <>
            <StyledGetStarted >
                <div className="container">
                    <div className="light-bg light-text shadow br-md py-4 px-3">
                        <div className="row align-items-center">
                            <div className="col-md-7 ">
                                <div className="pry py-4 px-5 br-md">
                                    <h4 className='yellow-text mb-4'>
                                        Excited To Get Started?
                                    </h4>
                                    <p className="">
                                        Follow these steps to begin your journey with us:
                                    </p>

                                    {homeGetStarted.map(({ title, content }, i) => {
                                        return (
                                            <div className="d-flex gap-3 mb-4" key={i}>
                                                <div className="">
                                                    <span className='yellow-bg px-2 br-lg'></span>
                                                </div>
                                                <div className="">
                                                    <h6 className="fw-bold m-0">
                                                        {title}
                                                    </h6>
                                                    <p className="m-0">
                                                        {content}
                                                    </p>
                                                </div>
                                            </div>
                                        );
                                    })}

                                    <div className="mt-5 text-center">
                                        <Link to="/register">
                                            <Button light className="btn btn-lg">
                                                Get Started
                                            </Button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-5 d-none d-sm-block text-center">
                                <img src={started_main} alt="Get started" width={'60%'} />
                            </div>
                        </div>
                    </div>
                </div>
            </StyledGetStarted>

        </>
    );
};

export default GetStarted;


const StyledGetStarted = styled.section`
    
padding: 4rem 0;
`;